import { Controller } from "@hotwired/stimulus"

// Billing: a company registered outside France has no SIRET. When the billing
// address or the country picker (`country` target, not saved) changes, shows the
// SIRET fields (`france` targets) or the VAT and company number fields (`abroad`
// targets). Hidden inputs are disabled, so they are neither sent nor checked by
// the browser. The server renders the first state. Switching abroad picks the
// "other" company type (`companyKind` target): the others are French legal forms.
// `siretCountries` and `normalize` mirror Practitioner::CompanyCountry.
export default class extends Controller {
  static targets = ["france", "abroad", "country", "companyKind"]
  static values = { siretCountries: Array }

  addressChanged ({ detail }) {
    const abroad = this.abroad(detail?.country)
    this.toggle(abroad)
    if (this.hasCountryTarget) this.countryTarget.value = abroad ? "other" : "france"
    if (abroad) this.chooseOtherCompanyKind()
  }

  countryChanged () {
    const abroad = this.countryTarget.value !== "france"
    this.toggle(abroad)
    if (abroad) this.chooseOtherCompanyKind()
  }

  // Still editable afterwards.
  chooseOtherCompanyKind () {
    if (!this.hasCompanyKindTarget || this.companyKindTarget.value === "other") return

    this.companyKindTarget.value = "other"
    this.companyKindTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  abroad (country) {
    const normalized = this.normalize(country)
    return Boolean(normalized) && !this.siretCountriesValue.includes(normalized)
  }

  normalize (country) {
    return (country || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/-/g, " ")
      .replace(/\s+/g, " ")
      .trim()
  }

  toggle (abroad) {
    this.franceTargets.forEach((element) => this.show(element, !abroad))
    this.abroadTargets.forEach((element) => this.show(element, abroad))
  }

  show (element, visible) {
    element.hidden = !visible
    element.querySelectorAll("input, select, textarea").forEach((input) => { input.disabled = !visible })
  }
}
